import React from 'react';
import styled from 'styled-components';
import zoomInfoChatIcon from "../../../assets/icons/ZI Chat logo.svg";

const InsentLinkContainer = styled.div`
  transition: all 80ms;
  padding: 10.5px 0;
  margin: 0 20px;
  height: 18px;
  display: flex;
  justify-content: center;
`;

const InsentLinkContent = styled.a`
  text-decoration: none;
  text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  border-radius: 16px;
  padding: 2px 8px;
  justify-content: center;
  color: ${p => p.theme.palette.grey7};
  font-size: 12px;
  line-height: 14px;
`;

const ZoomInfoChat = styled.img`
  margin-left: 8px;
  max-width: 42.76px;
  margin-top: 3px;
`;

const Divider = styled.div`
  height:100%;
  border-right: 1px solid black;
`

const PrivacyPolicyText = styled.a`
  color: #0061FF;
  font-size: 12px;
  line-height: 14.22px;
  padding: 2px 8px;
  display: flex;
  align-items: center;
  cursor: pointer;
  text-decoration: none;
`

const InsentLink = props => {
    const {
        children,
        show,
        privacyPolicy
    } = props

    const constructLink = (text) => {
        if(text.indexOf('http://')===0 || text.indexOf('https://') ===0)
            return text;
        else
            return `//${text}`;
    }

  return (
    <InsentLinkContainer id="insent-insent-link-insent-link-container" className="insent-link-container insent-home-link">
        {show && (<InsentLinkContent id="insent-insent-link-insent-link-content" href="https://zoominfo.com/chat" target="_blank">
        Powered by <ZoomInfoChat id="insent-insent-link-zoom-info-chat" src={zoomInfoChatIcon}/>
        </InsentLinkContent>)}
        {privacyPolicy && (
            <>
                {show && (<Divider />)}
                <PrivacyPolicyText href={constructLink(privacyPolicy?.url)} target="_blank">{privacyPolicy?.text}</PrivacyPolicyText>
            </>
        )}
    </InsentLinkContainer>
  );
};

// Powered by Insent AI
InsentLink.propTypes = {};

export default InsentLink;
